import React from "react";
import clsx from "clsx";
import MultiSelect from "../../Selects/MultiSelect";

export default class AccountBuilderProperties extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == 'properties',
      'tab-pane': true
    })

    var inputs = this.props.all_properties.map(property => {
      return {
          label_primary: `${property.name} - ${property.address}`,
          custom_label_secondary: property.account ? property.account.name : '',
          id: property.id
        }
      })

    return (
      <div className={tabClasses} id="properties">
        <div className="row">
          <div className="col-md-12">
          { 
          inputs.length
          ?
            <MultiSelect 
              header_primary="properties"
              inputs={inputs}
              selected_inputs={this.props.properties}
              onChange={this.props.onChangeProperties}/>
          : 
            <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
          }
          </div>
        </div>        
      </div>  
    )
  }

}